import React from 'react';
import './loading.css';

const LoadingComponent = () => {
  return <div className="loading">Loading</div>;
};

export default LoadingComponent;
